import React from 'react'
import { Icon } from './icon'

export const WarehouseIcon: React.FC<Icon> = ({
  color = '#2563eb',
  size = 24,
  marginBottom = '0px',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    width={size}
    height={size}
    color={color}
    style={{ marginBottom: marginBottom }}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
    />
  </svg>
)
